<template lang="html">
    <v-container fluid class="py-0">
        <v-row class="py-1">
            <v-col class="text-left pa-0">
            </v-col>
            <v-col class="pa-0 text-center">
                <v-tooltip top v-if="ignoreDate">
                    <template v-slot:activator="{ on }">
                        <v-btn small text v-on="on">
                            <v-icon color="grey" class="mr-1" >mdi-clock-alert</v-icon>
                            <display-date></display-date>
                        </v-btn>
                    </template>
                    <span>Using transaction ID as filter disable date criteria</span>
                </v-tooltip>

                <v-btn v-else small text @click="toggleDateTimePanel()" color="blue">
                    <v-icon  color="grey darken-2" class="mr-1">mdi-clock-outline</v-icon>
                    <display-date></display-date>
                </v-btn>
            </v-col>
            <v-col class="pa-0 text-right">
                <v-btn small text @click="toggleFiltersPanel()" color="blue">
                    <v-icon color="grey darken-2" class="mr-1">mdi-magnify</v-icon>
                    Filters
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'
    import {SEARCH_NS} from "@/store/modules/search/constants";
    import DisplayDate from "@/components/home/date/DisplayDate";

    export default {
        components: {DisplayDate},
        computed: {
            ...mapGetters(SEARCH_NS, [
                'ignoreDate'
            ])
        },
        methods: {
            ...mapActions(SEARCH_NS, [
                    'toggleBusinessUnitPanel',
                    'toggleDateTimePanel',
                    'toggleFiltersPanel'
                ]
            )
        }
    }
</script>
